/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ArticoloItem } from './articolo-item';
import { TipoConsumoArticolo } from './tipo-consumo-articolo';


export interface TransazioneVoucherArticoliBatchForm { 
    codice_voucher: string;
    id_negozio: string;
    tipo: TipoConsumoArticolo;
    articoli: Array<ArticoloItem>;
}



